import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store';
import * as AuthSelectors from 'src/app/store/auth/auth.selectors';
import { loadUserProfile } from 'src/app/store/user-profile/user-profile.actions';
import * as AppointmentActions from 'src/app/store/appointment/appointment.actions';
@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css'],
})
export class MainLayoutComponent implements OnInit {
  protected readonly isAuthenticated = this.store.select(
    AuthSelectors.selectIsAuthenticated
  );
  protected readonly currentUser = this.store.select(
    AuthSelectors.selectCurrentUser
  );

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.isAuthenticated.subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.currentUser.subscribe((currentUser) => {
          console.log(
            '🚀 ~ MainLayoutComponent ~ ngOnInit ~ currentUser:',
            currentUser
          );
          if (currentUser && currentUser.phoneNumber) {
            this.store.dispatch(
              loadUserProfile({ phoneNumber: currentUser.phoneNumber })
            );
            this.store.dispatch(AppointmentActions.loadUpcomingAppointments());
          }
        });
      }
    });
  }

  navigateToBusiness(): void {
      window.open('https://business.jujuja.com/', '_blank');
    }
}
